<template>
  <div class="profile-detail">
    <div class="profile-info-block">
      <div class="profile-edit-block">
        <h2 class="rg-title">メールアドレス</h2>
        <EditButton
            title="編集"
            @click="showModal"
          />
      </div>
   
      <div class="profile-info">
        <p class="email">{{ current_email }}</p>
      </div>
      <b-modal
        id="modal1"
        ref="modal"
        hide-footer
        size="lg"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        @shown="addEventListeners()"
        @hide="removeEventListeners()"
      >
        <template #modal-header>
          <!-- Emulate built in modal header close button action -->
          <!-- <img
            src="../assets/close.png"
            v-on:click.prevent="closeModal('email')"
            style="cursor:pointer;margin-top:5px"
          /> -->
          <h5 class="sharingTitle" style="margin-top:5px">
            メールアドレス
          </h5>
          <!-- <button
            data-v-bf1681ae=""
            title="保存"
            class="btn btn-secondary rounded btn-sm font-16 editBtn"
            @click="changeEmail"
          >
            保存
          </button> -->
        </template>
        <form v-on:submit.prevent="changeEmail" ref="form" class="email-form">
          <div class="form-wrap">
            <div class="form-sep-block" style="margin-bottom: 20px !important">
              <!-- <h3>メールアドレスの変更</h3> -->
              <div class="item-form-block">
                <div class="form-group row">
                  <div class="invalid-feedback ml-2" v-if="hasServerError('error_description')">
                    {{getServerErrorMessage('error_description')}}
                  </div>
                  <div class="col-12 mb-3">
                    <label class="cstm-label" style="color: #787878">
                      現在のメールアドレス
                    </label>
                    <div class="input-group custom-group">
                        {{ profile.email }}
                    </div>
                  </div>
                  <div class="col-12 mb-2">
                    <label class="cstm-label">
                      <span class="span-badge mr-2">必須</span>
                      新しいメールアドレス</label>
                    <div class="input-group custom-group">
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': hasError('email') }"
                        name="email"
                        v-model="email"
                        tabindex="4"
                        v-validate="'required|email'"
                        data-vv-as="email"
                        autocomplete="new-password"
                      />
                      <p class="mt-2" style="color:#787878; font-weight: 600;">
                        ※携帯キャリアメール（docomo・au・softbank等）は、メールが届かない場合があります。
                        別のメールアドレスを入力いただく事を推奨します。
                      </p>
                      <div class="invalid-feedback" v-if="hasError('email')">
                        {{ getErrorMessage("email") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-2">
                    <label class="cstm-label"> <span class="span-badge mr-2">必須</span>
                      現在のパスワード
                    </label>
                    <div class="input-group custom-group">
                      <input
                        :type="inputType"
                        class="form-control password-form"
                        :class="{
                          'is-invalid': hasError('current_password'),
                        }"
                        name="current_password"
                        v-model="current_password"
                        tabindex="5"
                        v-validate="'required|doubleByte'"
                        autocomplete="new-password"
                      />
                      <button
                        class="btn-eye"
                        type="button"
                        v-on:click.prevent="showPassword()"
                      >
                        <i :class="eyeIcon" aria-hidden="true"></i>
                      </button>
                      <div
                        class="invalid-feedback"
                        v-if="hasError('current_password')"
                      >
                        {{ getErrorMessage("current_password") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button
                  data-v-bf1681ae=""
                  title="保存"
                  class="btn btn-secondary rounded font-16 profile-edit-btn"
                  @click.prevent="changeEmail"
                >
                  この内容で保存する
                </button>
                <CancelModal @click="cancel"/>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal
        id="modal2"
        ref="modal1"
        hide-footer
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        @shown="addEventListeners"
        @hide="removeEventListeners"
      >
        <template #modal-header style="background:white;">
          <!-- Emulate built in modal header close button action -->
          <!-- <img
            src="../assets/close.png"
            v-on:click.prevent="closeModal('token')"
            style="cursor:pointer;margin-top:5px"
          /> -->
          <h5 class="sharingTitle" style="margin-top:5px">
            認証コードの確認
          </h5>
          <!-- <button
            data-v-bf1681ae=""
            title="保存"
            class="btn btn-secondary rounded btn-sm font-12 editBtn"
            @click="verifyToken"
          >
            保存
          </button> -->
        </template>
        <form v-on:submit.prevent="verifyToken">
          <div class="form-wrap mt-4">
            <div class="form-sep-block">
              <div class="item-form-block">
                <div class="form-group row">
                  <div class="col-12 mb-2" style="text-align: left;">
                    <label class="cstm-label" style="font-size:14.5px"
                      >新しいメールアドレスに届いた6桁の認証コードを入力してください</label
                    >
                  </div>
                  <div class="input-group custom-group token">
                    <input
                      type="text"
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': hasError('token'),
                      }"
                      name="token"
                      v-model="token"
                      v-validate="'required'"
                    />
                    <div class="invalid-feedback token-msg" v-if="hasError('token')">
                      
                      {{ getErrorMessage("token") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <button
                  data-v-bf1681ae=""
                  title="保存"
                  class="btn btn-secondary rounded font-16 profile-edit-btn"
                  @click.prevent="verifyToken"
                >
                  この内容で保存する
                </button>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import Api from '../config/api';
import logo from '../assets/Group300.png';
import { mapGetters, mapMutations } from 'vuex';
import modalEventListener from '../mixins/modalEventListener';
import CancelModal from './CancelModal.vue';
import EditButton from './EditButton.vue';

export default {
  name: 'ChangeEmail',
  mixins: [modalEventListener],
  components: {
    CancelModal,
    EditButton
  },
  data() {
    return {
      email: '',
      current_password: '',
      token: '',
      id: '',
      server_errors: {},
      disable: false,
      disableTokenButton: false,
      inputType: 'password',
      eyeIcon: 'fa-solid fa-eye-slash',
    };
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
    }),
    current_email() {
      return this.profile.email;
    },
  },
  methods: {
    ...mapMutations({
      mutateEmail: 'changeEmail',
    }),
    showModal() {
      this.$refs.modal.show();
    },
    cancel() {
      if (this.$refs.modal1 && this.$refs.modal1.isVisible) {
        this.closeModal('token');
      } else if (this.$refs.modal && this.$refs.modal.isVisible) {
        this.closeModal('email');
      }
    },
    closeModal(group) {
      if (group == 'email') {
        this.clearForm();
      }
      this.server_errors = {};
      return group === 'email'
        ? this.$refs.modal.hide()
        : this.$refs.modal1.hide();
    },
    hasError(field) {
      return (
        field in this.server_errors || this.errors.first(field) !== undefined
      );
    },
    hasServerError(field) {
      return !(this.server_errors.data == undefined);
    },
    getErrorMessage(field) {
      if (this.errors.first(field) !== undefined) {
        return this.errors.first(field);
      } else if (field in this.server_errors) { return this.server_errors[field].msg; }
      return null;
    },
    getServerErrorMessage(field) {
      if (this.server_errors.data == undefined) return null;
      return this.server_errors.data.error_description;
    },
    clearErrors() {
      // clear errors
      this.server_errors = {};
    },
    showPassword() {
      if (this.inputType === 'password') {
        this.inputType = 'text';
        this.eyeIcon = 'fa-solid fa-eye';
      } else {
        this.inputType = 'password';
        this.eyeIcon = 'fa-solid fa-eye-slash';
      }
    },
    async changeEmail() {
      this.disable = true;
      try {
        const check = await this.$validator.validateAll();
        if (check) {
          const token = await this.$auth.getToken();
          const res = await this.axios({
            method: 'post',
            data: {
              email: this.email,
              current_password: this.current_password,
            },
            url: Api.url(Api.endpoints.changeEmail),
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (res) {
            this.$refs.modal1.show();
            this.server_errors = {};
          }
        }
      } catch (error) {
        if (error.response.status === 422) {
          this.server_errors = error.response.data;
        } else if (error.response.status === 503) {
          this.$router.push({ name: 'Logout' });
        } else {
          await swal({
            text:
              error && error.response.data.message
                ? error.response.data.message
                : 'メールアドレスの変更に失敗しました。少し時間を置いて再度お試しください。',
            icon: 'warning',
          });
          // this.$router.push({ name: 'home' });
        }
      }
      this.disable = false;
    },
    clearForm() {
      this.email = '';
      this.current_password = '';
    },
    async verifyToken() {
      this.disableTokenButton = true;
      try {
        const check = await this.$validator.validateAll();
        if (check) {
          const content1 = document.createElement('span');
          content1.innerHTML = '<p style="font-weight:bold">メールアドレスを更新しますか？</p>';
          const res = await swal({
            // title:
            //   "メールアドレスを変更します。続行する場合はOKをクリックしてください。",
            icon: 'warning',
            content: content1,
            className: 'custom-swal5',
            closeOnClickOutside: false,
            buttons: {
              cancel: 'キャンセル',
              ok: '更新する',
            },
          });
          if (res) {
            const token = await this.$auth.getToken();
            const result = await this.axios({
              method: 'post',
              data: {
                token: this.token,
                // _id: this.id,
              },
              url: Api.url(Api.endpoints.verifyNewEmail),
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            this.mutateEmail(this.email);
            this.$refs.modal1.hide();
            const content = document.createElement('span');
            content.innerHTML = '<p style="font-weight:bold">メールアドレスを更新しました。</p>';
            await swal({
              title: '',
              content,
              className: 'custom-swal4',
              icon: logo,
              buttons: {
                ok: 'OK',
              },
            });
            this.clearForm();
            this.$refs.modal.hide();
            // this.$router.push({ name: "home" });
          }
        }
      } catch (error) {
        if (error.response.status === 422) {
          this.server_errors = error.response.data;
        } else if (error.response.status === 503) {
          this.$router.push({ name: 'Logout' });
        } else {
          this.server_errors =
            error && error.response && error.response.data
              ? error.response.data
              : '';
          await swal({
            text:
              error && error.response && error.response.data.message
                ? error.response.data.message
                : 'メールアドレスの変更に失敗しました。少し時間を置いて再度お試しください。',
            icon: 'warning',
          });
        }
      }
      this.disableTokenButton = false;
      // this.email='';
      // this.password='';
    },
  },
};
</script>

<style scoped>
.form-wrap {
  margin-bottom: 0px !important;
}
.form-sep-block {
  padding: 0px !important
}
.invalid-feedback.token-msg{
  text-align: right;
}
.form-control.is-valid{
  background-image: none;
}
.email-form {
  padding: 20px;
}
/deep/ #modal > .modal-dialog > .modal-content > .modal-header {
  background: #ffffff;
}
.email {
  color: #787878;
  font-weight: 600;
}
.input-group.custom-group.token {
  padding: 0px 23px 0px 23px !important;
}
.item-form-block .form-control {
  min-height: 40px;
}

/* .editBtn {
  width: 120px;
  height: 50px;
  background: #006c6b;
  color: white;
  border: #227744;
  font-weight: bold;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  font-size: 18px;
}

.editBtn:hover {
  background: #1a5b34;
} */
/* .btn {
  border-radius: 8px;
} */
.password-form {
  background-image: none;
}
.btn-eye {
  /* margin-top: 10px; */
  margin-right: 10px;
}
.cancel {
  width: 49%;
  height: 48px;
  border: none;
  padding: 12px 20px;
}
.submit {
  width: 49%;
  height: 48px;
  padding: 12px 20px;
  border: none;
  margin-left: 12px !important;
}
/deep/ #modal > .modal-dialog > .modal-content > .modal-header {
  background: #006c6b;
}

>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}

@media (max-width: 767px) {
  .editBtn {
    width: 100px !important;
    height: 50px !important;
  }

  .email-form {
    padding: 10px !important;
  }
}

@media (max-width: 550px) {
  .cancel {
    width: 48%;
  }
  .submit {
    width: 48%;
    margin-left: 12px !important;
  }
  .email {
    word-break: break-word;
    max-width: 230px;
  }
}
@media (max-width: 320px) {
  .cancel {
    width: 48%;
  }
  .submit {
    width: 48%;
    margin-left: 5px !important;
  }
  .email {
    max-width: 140px;
  }
}
</style>
